import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { EffortsResolver } from './resolvers/efforts.resolver';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { EffortsService } from './services/efforts.service';
import { ProjectsResolver } from './resolvers/projects.resolver';
import { ProjectsService } from './services/projects.service';
import { OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { environment, OAuthConfig } from '../environments/environment';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { CommunityAuthService } from './services/community-auth.service';
import { DatePipe } from '@angular/common';
import { TimesheetService } from './services/time-sheet.service';
import { GroupsService } from './services/groups.service';
import { GroupMembersService } from './services/group-members.service';
import { FilterChipUtilityService } from './services/filter-chip-utility.service';
import { ProjectMembersService } from './services/project-members.service';
import { CurrentUserResolver } from './resolvers/current-user.resolver';
import { UsersService } from './services/user.service';
import { catchError, filter, firstValueFrom, from, lastValueFrom, switchMap, tap } from 'rxjs';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FeedbackService } from './services/feedback.service';
import { PendingChangesGuard } from './guards/can-deactivate.guard';
import { AuthHeaderInterceptor } from './interceptors/auth-header.interceptor';
import { HighlightPipe } from './pipes/highlight.pipe';
import { DefaultQueries } from './services/default-queries.service';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    provideOAuthClient({ resourceServer: { allowedUrls: [environment.apiUrl], sendAccessToken: true } }),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    EffortsResolver, EffortsService, ProjectsResolver, CurrentUserResolver, ProjectsService, TimesheetService, FeedbackService, DefaultQueries,
    GroupsService, GroupMembersService, ProjectMembersService, AuthGuard, RoleGuard, PendingChangesGuard, CommunityAuthService, DatePipe, HighlightPipe, FilterChipUtilityService, UsersService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
    provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideAnimations(), provideDateFnsAdapter(), provideHttpClient(withInterceptors([]), withInterceptorsFromDi()),
    provideAppInitializer(async () => {
      const initialUrl = window.location.href;
      console.log("Initial URL", initialUrl);
      if (new URL(initialUrl).pathname.startsWith("/help")) return;
      
      const userService = inject(UsersService);
      const oauthService = inject(OAuthService);
      const authService = inject(CommunityAuthService);
      const router = inject(Router);
      oauthService.configure(OAuthConfig);

      //this.oauthService.events.subscribe(e => console.log("event, e", e));
      const loggedIn = await authService.runInitialLoginSequence(environment.loadDiscoveryDoc, initialUrl);
      if (!loggedIn)
        return false;

      try {
        await firstValueFrom(userService.loadCurrentUser());
        return true;
      } catch(err) {
        console.error(err);
        router.navigate(["/unauthorized"]);
        return false;
      }
    })
  ]
};
